import React, { PureComponent } from 'react';
const config = ARTICLE_CONFIG;

import { numberFormat } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';
import Utils from '~/core/scripts/utils';

import './ResultCard.styl';

function getSharingSentence(shareTitle, above, below) {
  return `${shareTitle}: ${getComparisonSentence(above, below, 'ich')}`;
}

function getTwitterSentence(shareTitle, above, below) {
  return getSharingSentence(shareTitle, above, below) + ' ' + config.meta.ogUrl;
}

function getFacebookSentence(shareTitle, above, below) {
  return getSharingSentence(shareTitle, above, below);
}

function getTitle(error) {
  let sentence = 'Weiter daneben hätten Sie kaum liegen können.';

  if (error === 0) {
    sentence = 'Sie haben die Entwicklung exakt richtig eingezeichnet!';
  } else if (error <= 5) {
    sentence = 'Sie haben die Entwicklung sehr genau getroffen.';
  }else if (error <= 10) {
    sentence = 'Ihre Schätzung ist ziemlich gut.';
  } else if (error <= 20) {
    sentence = 'Sie liegen etwas daneben.';
  } else if (error <= 60) {
    sentence = 'Sie liegen ganz schön daneben.';
  }

  return sentence;
}

function getComparisonSentence(above, below, pronoun = 'Sie') {
  let sentence = `${numberFormat(below, 1)} Prozent der Nutzer haben besser geschätzt als ${pronoun}.`;

  // how many results are as good as mine
  const selfPercentage = 100 - above - below;

  if (below === 0) {
    sentence = `Bisher hat niemand die Entwicklung besser eingeschätzt als ${pronoun}.`;
  } else if (below <= 5) {
    const formattedSelfPercentage = numberFormat(selfPercentage);
    const prefix = formattedSelfPercentage === '1' ? 'Ein' : formattedSelfPercentage;
    const verb = formattedSelfPercentage === '1' ? 'hat' : 'haben';
    sentence = `${prefix} Prozent der Nutzer ${verb} genauso gut geschätzt wie ${pronoun}.`;
  } else if (below <= 50) {
    const prefix = pronoun === 'ich' ? 'Ich habe' : 'Sie haben';
    sentence = `${prefix} besser geschätzt als ${numberFormat(above, 1)} Prozent der Nutzer.`;
  } else if (above === 0) {
    sentence = `Bisher hat sich niemand stärker verschätzt als ${pronoun}.`;
  }

  return sentence;
}

class ResultCard extends PureComponent {
  onFbShare = () => {
    FB.ui({
      method: 'share',
      href: config.meta.ogUrl,
      quote: getFacebookSentence(this.props.shareTitle, this.props.data.above, this.props.data.below)
    }, resp => {
      console.log(resp);
    });
  }

  render() {
    if (!this.props.data) {
      return null;
    }

    const { onRedraw, data, shareTitle } = this.props;
    const { count, above, below, error } = data;

    return (
      <div className="resultcard">
        <div className="resultcard__wrap">
          <div className="resultcard__body">
            <div className="resultcard__title">
              {getTitle(error)}
            </div>
            <div className="resultcard__subtitle">
              {getComparisonSentence(above, below)}
            </div>
            <div className="resultcard__repeat" onClick={onRedraw}>
              <Icon type="refresh" /> Nochmal zeichnen!
            </div>
          </div>
          {/* <div className="resultcard__social">
            <div className="resultcard__social-item fb" onClick={this.onFbShare}>
              <Icon type="fb" /> Auf Facebook teilen
            </div>
            <a
              className="resultcard__social-item tw"
              target="_blank"
              href={`https://twitter.com/intent/tweet?source=${encodeURIComponent(config.meta.ogUrl)}&text=${encodeURIComponent(getTwitterSentence(shareTitle, above, below))}`}
            >
              <Icon type="tw" /> Auf Twitter teilen
            </a>
          </div> */}
        </div>
        <div className="resultcard__count">Teilnehmer: {count}</div>
      </div>
    );
  }
}

export default ResultCard;